import { Injectable } from '@angular/core';
import { CartCalculationSummaryTaxModel, ProductBaseWithQuantityModel } from '@libs/shop/models';

@Injectable({
  providedIn: 'root',
})
export class PriceCalculationService {
  public calculateTaxesForProducts(products: ProductBaseWithQuantityModel[]): CartCalculationSummaryTaxModel[] {
    const netPricesByTaxRate: Map<number, number> = products.reduce((taxRates, product) => {
      const taxRate: number = Number(product.details?.taxRate);

      if (!Number.isFinite(taxRate)) {
        return taxRates;
      }

      const productNetPrice: number = (product.prices?.salesUnit ?? 0) * product.quantity;

      taxRates.set(taxRate, (taxRates.get(taxRate) ?? 0) + productNetPrice);

      return taxRates;
    }, new Map<number, number>());

    return Array.from(netPricesByTaxRate, ([taxRate, net]) => ({
      taxRate,
      amount: Math.round(net * taxRate / 100),
    }));
  }

  public calculateTaxAmountForTaxItems(taxItems: CartCalculationSummaryTaxModel[]): number {
    return taxItems.reduce((sum, currentTax) => sum + currentTax.amount, 0);
  }

  public calculateNetPriceForProducts(products: ProductBaseWithQuantityModel[]): number {
    return products.reduce((a, b) => a + (b.prices?.salesUnit ?? 0) * b.quantity, 0);
  }
}
